var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseSensitive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.088,
    height: 14.087,
    viewBox: "0 0 14.088 14.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.088,
    height: 14.087,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    transform: "translate(0.544 0.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.088,1.087H13V13H1.088ZM0,14.087H14.088V0H0Z",
    fill: "#dfe0e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.055,9.732,4.2,3.764H5.243L7.391,9.732H6.435L5.89,8.153H3.559L3.011,9.732ZM5.628,7.395,4.747,4.848H4.7L3.82,7.395Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,8.468c0-1.017.869-1.239,1.717-1.338.8-.093,1.131-.087,1.131-.405V6.7A.745.745,0,0,0,9.8,5.9a1.046,1.046,0,0,0-1.041.624L7.936,6.34A1.809,1.809,0,0,1,9.784,5.2,1.52,1.52,0,0,1,11.521,6.76V9.733h-.85V9.121h-.036a1.4,1.4,0,0,1-1.323.711A1.36,1.36,0,0,1,7.8,8.468m2.851-.35V7.541a3.418,3.418,0,0,1-1.079.239c-.5.067-.918.233-.918.7,0,.432.356.653.849.653A1.05,1.05,0,0,0,10.65,8.118"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseSensitive);
export default __webpack_public_path__ + "static/media/CaseSensitive.1fcbcae6caccf7bf44226bcef2c26218.svg";
export { ForwardRef as ReactComponent };